// ======================= tooltip code
// Function to scroll to top smoothly
let tooltip = null
const hideTooltip = () => {
  if (tooltip) {
    const tooltipDiv = document.querySelector('.zipcode_bar_input_1528')
    tooltipDiv.removeChild(tooltip)
    tooltip = null
  }
}
// Function to create and show tooltip
const showTooltip = () => {
  // Don't show tooltip if button is not disabled

  // Remove existing tooltip if any
  // hideTooltip()
   scrollToTop()

  tooltip = document.createElement('div')
  tooltip.className = 'tooltipTest'
  tooltip.style.cssText = `
    position: absolute;
    display: block;
    background: #4caf50;
    color: #ffffff;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 14px;
    white-space: nowrap;
    z-index: 1000;
    top: -35px;
    left: 83px;
  `
  tooltip.innerText = 'Please enter a pincode!'

  const arrow = document.createElement('div')
  arrow.className = 'arrow-bottom-1511'
  arrow.style.cssText = `
    position: absolute;
    top: 39px;
    left: 0;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #4caf50;
  `

  tooltip.appendChild(arrow)

  const tooltipDiv = document.querySelector('.zipcode_bar_input_1528');
  const rect = tooltipDiv.getBoundingClientRect()
  tooltipDiv.appendChild(tooltip)
  setTimeout(hideTooltip, 4000)
}


const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};
const addToCartButton = document.querySelector('#AddToCartSticky')

const setupButton = (addToCartButton) => {
  // console.log('setupButton', addToCartButton);
  if (!addToCartButton) return;
  addToCartButton.disabled = false
  const clickOverlay = addToCartButton.previousElementSibling
  
  clickOverlay?.removeEventListener('click', handleButtonClick)
  
  // Add new click listener
  clickOverlay?.addEventListener('click', handleButtonClick)
  
  // Style modifications for disabled state
  if (addToCartButton.disabled) {
    addToCartButton.style.pointerEvents = 'auto';
    addToCartButton.title = 'Enter pin code first';
  } else {
    addToCartButton.style.pointerEvents = '';
    addToCartButton.title = '';
  }
};

// Handle button click
const handleButtonClick = (event) => {
  
  // console.log('handleButtonClick', event);
  const button = event.currentTarget;
  
  // If button is disabled, prevent default action
  if (button.disabled) {
    event.preventDefault();
    event.stopPropagation();
    return;
  }
  
  showTooltip()

};

// Initial setup

if (addToCartButton.disabled) {
  setupButton(addToCartButton)
}

// Setup observer to watch for button changes
const productAddToCartContainer = document.querySelector('.product-add-to-cart-container');
if (productAddToCartContainer) {
  const config = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled']
  };
  
  const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      const addToCartButton = document.querySelector('#AddToCartSticky');
      if (!addToCartButton) continue;
      
      if (mutation.type === 'childList' || 
          (mutation.type === 'attributes' && mutation.attributeName === 'disabled')) {
        setupButton(addToCartButton);
      }
    }
  };
  
  const observer = new MutationObserver(callback);
  observer.observe(productAddToCartContainer, config);
}